import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '../../query-client';
import { IPagination } from '../IPagination';
import { fetchVendorBillItems } from './index';
import { IFetchPageQuery } from '../IFetchQueryOptions';
import { IVendorBillItem } from './interface';

export const useVendorBillItemsListQuery = (query: IFetchPageQuery, options = {}) => {
    return useQuery<IPagination<IVendorBillItem>, Error>({
        queryKey: [QueryKey.VENDOR_BILL_ITEMS, query],
        queryFn: ({ signal }) => fetchVendorBillItems(query, signal),
        ...options,
    });
};
